import { t } from 'i18next';

export const FILTERED_MENU = {
  ALL: t('NewTradingPhotoCardMarket.filterMenu.all'),
  ONGOING: t('NewTradingPhotoCardMarket.filterMenu.ongoing'),
  COMPLETED: t('NewTradingPhotoCardMarket.filterMenu.completed')
};
